import { useNavigate } from 'react-router-dom'
import { LessonCard } from '@shared/ui/lesson-card/lesson-card'
import { EmptyState } from '../empty-state/empty-state'
import s from './lessons-list.module.scss'

export const LessonsList = ({ lessons, role, mapLesson, onOpenCancelModal, onLeaveReview, onAttachReceipt, onOpenLesson }) => {
    const navigate = useNavigate()

    if (!lessons.length) {
        return <EmptyState text='У вас пока что нет занятий' />
    }

    const handleOpen = (lessonId) => {
        if (onOpenLesson) {
            onOpenLesson(lessonId)
            return
        }
        navigate(`/appointment/${lessonId}`)
    }

    return (
        <div className={s.wrapper}>
            {lessons.map((lesson) => (
                <LessonCard
                    key={lesson?.id}
                    role={role}
                    onCancel={() => onOpenCancelModal(lesson?.id)}
                    onLeaveReview={onLeaveReview ? () => onLeaveReview(lesson?.teacher?.id) : undefined}
                    onAttachReceipt={onAttachReceipt ? (file) => onAttachReceipt(lesson?.id, file) : undefined}
                    onOpen={() => handleOpen(lesson?.id)}
                    {...mapLesson(lesson)}
                />
            ))}
        </div>
    )
}
